<div id="banner-calculadora-factoring" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-sm-11 col-md-10 col-lg-8">
                        <p class="d-inline-block p-display-bold border-y-1 border-primary-900 primary-900 mb-2">CALCULADORA FACTORING</p>
                <h1 class="h1-display primary-900 mb-3 mb-lg-2"><span class="secondary-factoring-600">Optimiza</span> tu inversión</h1>

                <div class="d-none d-lg-block">
                    <p class="p-display primary-900">
                    Herramienta que permite calcular una simulación de tus ganancias basadas en diferentes escenarios financieros adaptados
                    a ti.
                    </p>
                </div>
                <div class="mt-lg-4">
                    <app-btn-link [linkId]="'btn-banner-calculadora-factoring'" [linkTitle]="'Más información'" [linkType]="'routerLink'" [linkUrl]="'calculadora-rentabilidad'"></app-btn-link>
                </div>
            </div>
        </div>
    </div>
</div>